const StatusBadge = ({ status }) => {
    const getStatusStyle = () => {
        switch (status) {
        case 'approved':
            return 'bg-green-500';
        case 'pending':
            return 'bg-yellow-500';
        case 'rejected':  
            return 'bg-red-500';
        default:
            return 'bg-gray-500';
        }
    };
    const statusMap = {
        approved: 'Aprobada',
        pending: 'Pendiente',
        rejected: 'Rechazada',
    };
    const statusText = statusMap[status] || 'Desconocido';
    return (
        <span className={`px-3 py-1 rounded-full text-sm text-white font-extrabold transition-all ${getStatusStyle()}`}>
            {statusText}
        </span>
    );
};
export default StatusBadge;